module.exports = __webpack_public_path__ + "static/media/minimize.fb2dedbd.svg";